"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var eventClick = function (event) {
    var _a, _b;
    var eventData = {
        event: analytics_layer_1.LinkInteractionEventNames.EventClick,
        eventInfo: analytics_layer_1.LinkInteractionEventNames.EventClick,
        eventComponent: {
            badgeName: ((_b = (_a = event === null || event === void 0 ? void 0 : event.eventData) === null || _a === void 0 ? void 0 : _a.eventComponent) === null || _b === void 0 ? void 0 : _b.badgeName) || consts_1.NOT_AVAILABLE,
        },
    };
    return eventData;
};
exports.eventClick = eventClick;
